"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
const validation_1 = __importDefault(require("../../../../../validation"));
const getParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
};
const getQueryRules = {
    metric: validation_1.default.rules.array().of(validation_1.default.rules.string().oneOf([
        'score',
        'legallySpeaking',
        'topPrivacyIssues',
        'topPrivacyIssuesScore',
        'benchmarkScore',
    ]).required()).required().min(1)
        .label('Metric'),
};
const getQuery = {
    rules: getQueryRules,
    schema: validation_1.default.schema(getQueryRules),
};
const getParams = {
    rules: getParamRules,
    schema: validation_1.default.schema(getParamRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.get = {
    params: getParams,
    query: getQuery,
};
